import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ContextHelper from '../ContextHooks/ContextHelper';
import Cookies from 'js-cookie';

const RouteProtecter = ({ children }) => {
  const location = useLocation();
  const currentRoute = location.pathname;
  const patientToken = Cookies.get('patient_token');
  const { currentUser } = ContextHelper();

  const publicRoutes = ['/login', '/subscription-expired', '/patient-verification'];

  const permissions =
    typeof currentUser?.permissions === 'string' ? JSON.parse(currentUser.permissions) : currentUser?.permissions || {};

  const hasPermission = (key) => permissions?.[key] === true || permissions?.[key] === 'true';

  if (!currentUser || Object.keys(currentUser).length === 0) {
    if (!publicRoutes.includes(currentRoute)) {
      return <Navigate to="/login" replace />;
    }
  }

  if (currentUser && Object.keys(currentUser).length > 0 && publicRoutes.includes(currentRoute)) {
    return <Navigate to="/view-report" replace />;
  }
  if (currentUser && currentUser.token && currentRoute === '/subscription-expired') {
    return <Navigate to="/view-report" replace />;
  }

  if (currentUser && currentUser.expiryDate && !publicRoutes.includes(currentRoute)) {
    const expiryDate = new Date(parseInt(currentUser.expiryDate));
    const currentDate = new Date();
    const differenceInTime = expiryDate - currentDate;
    const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);
    if (differenceInDays < -5 && currentRoute !== '/subscription-expired') {
      return <Navigate to="/subscription-expired" replace />;
    }
  }

  if ((!currentUser || Object.keys(currentUser).length === 0) && publicRoutes.includes(currentRoute)) {
    return children;
  }

  if (patientToken) {
    return <Navigate to="/patient-report" replace />;
  }

  const isAdmin = currentUser?.isadmin;
  const isSuperAdmin = currentUser?.type === 'superadmin';
  const isDoctor = currentUser?.type === 'Doctor';
  const isVerifier = currentUser?.type === 'verifier';

  if (isAdmin) {
    const adminRestrictedRoutes = [
      '/view-report',
      '/subscription-agent',
      '/report-upload',
      '/patient-registration',
      '/patient-billing',
    ];
    if (adminRestrictedRoutes.includes(currentRoute)) {
      return <Navigate to="/add-report" replace />;
    }
  }

  if (!isAdmin) {
    if (currentRoute === '/patient-registration' && !hasPermission('patient_registration')) {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/patient-billing' && !hasPermission('patient_billing')) {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/add-report') {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/create-user') {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/add-verifier') {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/verifier') {
      return <Navigate to="/view-report" replace />;
    }
  }

  if (isDoctor && currentRoute === '/create-user') {
    return <Navigate to="/update-doctor" replace />;
  }
  if (isDoctor && currentRoute === '/add-verifier') {
    return <Navigate to="/update-doctor" replace />;
  }
  if (isDoctor && currentRoute === '/verifier') {
    return <Navigate to="/update-doctor" replace />;
  }
  if (isVerifier && currentRoute === '/create-user') {
    return <Navigate to="/view-report" replace />;
  }
  if (isAdmin && !hasPermission('add_verifier') && currentRoute === '/verifier') {
    return <Navigate to="/view-report" replace />;
  }
  if (isAdmin && !hasPermission('add_verifier') && currentRoute === '/add-verifier') {
    return <Navigate to="/view-report" replace />;
  }
  if (!hasPermission('add_verifier') && currentRoute === '/verifier') {
    return <Navigate to="/add-report" replace />;
  }
  if (!hasPermission('add_verifier') && currentRoute === '/add-verifier') {
    return <Navigate to="/add-report" replace />;
  }
  if (isSuperAdmin && currentRoute === '/add-verifier') {
    return <Navigate to="/view-report" replace />;
  }
  if (isSuperAdmin && currentRoute === '/verifier') {
    return <Navigate to="/view-report" replace />;
  }

  if (currentRoute === '/add-new-study' && !hasPermission('add_study')) {
    return <Navigate to="/view-report" replace />;
  }
  if (currentRoute === '/turnaround-time' && !hasPermission('turnaround_time') && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }
  if (currentRoute === '/business-revenue' && !hasPermission('business_revenue') && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  if (currentRoute === '/users' && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }
  if (currentRoute === '/subscription-admin' && !isSuperAdmin) {
    return <Navigate to="/view-report" replace />;
  }

  return children;
};

export default RouteProtecter;
